import { CoverPending } from './CoverPending';
import React from 'react';
import { mainGuide } from '../data/resources';
import { guideInteriorPages } from '../data/pendingContent';
const topics = [{
  title: 'Materialen en gereedschap',
  text: 'Leer garen, punnikklosjes en handig gereedschap kennen en ontdek waarvoor je ze gebruikt.'
}, {
  title: 'De basistechniek',
  text: 'Raak vertrouwd met punniken en met de eerste stappen.'
}, {
  title: 'Punnikkoord maken',
  text: 'Maak je punnikkoord en steek er metaaldraad doorheen als je project daarom vraagt.'
}, {
  title: 'Vormen maken',
  text: 'Gebruik het sjabloon als houvast om letters, hartjes en kleine motieven vorm te geven.'
}, {
  title: 'Afwerken',
  text: 'Werk de uiteinden en details netjes af, zodat je creatie zo mooi mogelijk uitkomt.'
}];
export function MainGuide() {
  return <section aria-labelledby="guide-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-133" data-mp="c7wlqdiblm4i">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-134" data-mp="h4n3d59rwps1">
        <div className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-135" data-mp="3pzn2skya16j5">
          <div className="rounded-[2rem] bg-blush overflow-hidden aspect-square shadow-soft" data-id="element-136" data-mp="3lz343cy21uuw">
            {mainGuide.image ? <img src={mainGuide.image} alt={mainGuide.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-137" data-mp="3t83ehehrl47" /> : <CoverPending title={mainGuide.name} data-id="element-138" data-mp="3v0sxgobhz3vb" />}
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-139" data-mp="379ndpy2frrfq">
          <p className="text-sm font-semibold text-berry-deep" data-id="element-140" data-mp="37agfslqg9srj">De hoofdhandleiding</p>
          <h2 id="guide-title" className="mt-2 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-141" data-mp="32cf08as8gbkt">
            {mainGuide.name}
          </h2>
          <p className="mt-3 font-serif italic text-lg sm:text-xl text-ink" data-id="element-142" data-mp="3c8rouu8x7z8p">{mainGuide.benefit}</p>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/80 max-w-xl" data-id="element-143" data-mp="2oj5oi3gtbdz4">
            {mainGuide.description}
          </p>

          <ol className="mt-10 border-t border-ink/10" data-id="element-144" data-mp="2jk2tzcygkq5e">
            {topics.map((t, i) => <li key={t.title} className="grid grid-cols-[2.5rem_1fr] gap-x-3 py-5 border-b border-ink/10" data-id="element-145" data-mp="ngekmglp7lhc" data-mpi={i}>
                <span className="font-serif text-xl font-semibold text-berry-deep leading-snug" data-id="element-146" data-mp="sf9dychaksfp">
                  {i + 1}
                </span>
                <div data-id="element-147" data-mp="118ut3wxdcbpn">
                  <h3 className="font-serif text-lg sm:text-xl font-semibold text-plum" data-id="element-148" data-mp="1194aiw4clajq">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-base leading-relaxed text-ink/75" data-id="element-149" data-mp="4kg6x4tdpptu">{t.text}</p>
                </div>
              </li>)}
          </ol>

          {guideInteriorPages.length > 0 && <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-150" data-mp="diiek37mbgq3">
              {guideInteriorPages.map(page => <div key={page.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-blush shadow-soft" data-id="element-151" data-mp="ij66qs7l23lw">
                  <img src={page.src} alt={page.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-152" data-mp="1oy71wvosahrf" />
                </div>)}
            </div>}
        </div>
      </div>
    </section>;
}